var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailBoxesSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.333 12.667h-6c-.184 0-.333-.15-.333-.334v-5C0 5.495 1.495 4 3.333 4s3.334 1.495 3.334 3.333v5c0 .184-.15.334-.334.334zM.667 12H6V7.333c0-1.47-1.196-2.666-2.667-2.666-1.47 0-2.666 1.196-2.666 2.666V12z",
    transform: "translate(-135 -358) translate(99 106) translate(0 240) translate(36 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 12.667H6.333c-.184 0-.333-.15-.333-.334 0-.184.15-.333.333-.333h9V7.333c0-1.47-1.196-2.666-2.666-2.666H3.333c-.184 0-.333-.15-.333-.334C3 4.15 3.15 4 3.333 4h9.334C14.505 4 16 5.495 16 7.333v5c0 .184-.15.334-.333.334z",
    transform: "translate(-135 -358) translate(99 106) translate(0 240) translate(36 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16c-.184 0-.333-.15-.333-.333v-3.334c0-.184.149-.333.333-.333.184 0 .333.15.333.333v3.334c0 .184-.149.333-.333.333zM2.333 4.667c-.184 0-.333-.15-.333-.334v-4C2 .15 2.15 0 2.333 0c.184 0 .334.15.334.333v4c0 .184-.15.334-.334.334z",
    transform: "translate(-135 -358) translate(99 106) translate(0 240) translate(36 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.667 2.667H2.333c-.184 0-.333-.15-.333-.334v-2C2 .15 2.15 0 2.333 0h3.334C5.85 0 6 .15 6 .333v2c0 .184-.15.334-.333.334zm-3-.667h2.666V.667H2.667V2z",
    transform: "translate(-135 -358) translate(99 106) translate(0 240) translate(36 12)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBoxesSmall);
export default __webpack_public_path__ + "static/media/mail-boxes-small.8b4feaf7.svg";
export { ForwardRef as ReactComponent };